import script from "./rakuintroduce.vue?vue&type=script&setup=true&lang=js"
export * from "./rakuintroduce.vue?vue&type=script&setup=true&lang=js"

import "./rakuintroduce.vue?vue&type=style&index=0&id=2aaff4d9&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aaff4d9"]])

export default __exports__